module.exports = __webpack_public_path__ + "static/pattern-angles-040f92ff9f542e50c4cc31093d3482bf.svg";